
import $ from 'jquery';

function FormFileTitle(props) {
  return (
    <form action="#" method="post">
        <input type="hidden" name="uuid" value="" />
        <input type="text" className="form-control form-control-sm" name="title" style={{width: "350px"}} required placeholder="Insert new title" />
        <button type="submit" className="btn btn-primary btn-sm">Submit</button>
    </form>
  );
}

export function initFormFileTitle(dom) {
  
};

export default FormFileTitle;
